// src/composables/useImageConverter.ts
import { ref } from 'vue';

export function useImageConverter() {
    const selectedImage = ref<string | null>(null);
    const error = ref<string | null>(null);

    const handleFileChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const files = target.files;

        if (files && files.length > 0) {
            const file = files[0];

            if (file.type === 'image/png' || file.type === 'image/jpeg') {
                const reader = new FileReader();

                reader.onload = () => {
                    selectedImage.value = reader.result as string;
                };

                reader.onerror = () => {
                    error.value = 'There was an error reading the file.';
                };

                reader.readAsDataURL(file);
            } else {
                error.value = 'Please select a PNG or JPEG image.';
            }
        } else {
            error.value = 'No file selected.';
        }
    };

    return {
        selectedImage,
        error,
        handleFileChange,
    };
}
